module.exports = __webpack_public_path__ + "static/Fotografias_caracteristicas_4-101e8216e88f0bfd492644fb9b85898f.jpg";